/* eslint-disable react/prop-types */
import { Box, IconButton, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined';

const formatSize = (bytes) => {
  if (!bytes) return '0 B';
  const kb = bytes / 1024;
  if (kb < 1024) return `${kb.toFixed(1)} KB`;
  return `${(kb / 1024).toFixed(1)} MB`;
};

export default function FilePreview({ file, onRemove }) {
  const isImage = file.type?.startsWith('image/');
  const previewUrl = isImage ? URL.createObjectURL(file) : null;

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 1,
        px: 1,
        py: 0.75,
        borderRadius: 2,
        border: '1px solid',
        borderColor: 'grey.200',
        bgcolor: 'white',
        minWidth: 0,
        maxWidth: 180,
      }}
    >
      {isImage ? (
        <Box
          component="img"
          src={previewUrl}
          alt={file.name}
          sx={{ width: 36, height: 36, borderRadius: 1, objectFit: 'cover', flexShrink: 0 }}
        />
      ) : (
        <Box
          sx={{
            width: 36,
            height: 36,
            borderRadius: 1,
            bgcolor: 'grey.100',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            flexShrink: 0,
            color: 'grey.600',
          }}
        >
          <DescriptionOutlinedIcon fontSize="small" />
        </Box>
      )}
      <Box sx={{ minWidth: 0, flex: 1 }}>
        <Typography variant="caption" sx={{ display: 'block', fontWeight: 600, color: 'grey.800' }} noWrap>
          {file.name}
        </Typography>
        <Typography variant="caption" sx={{ color: 'grey.500', fontSize: 10 }}>
          {formatSize(file.size)}
        </Typography>
      </Box>
      <IconButton size="small" onClick={onRemove} sx={{ p: 0.5 }}>
        <CloseIcon sx={{ fontSize: 14 }} />
      </IconButton>
    </Box>
  );
}
